import React from "react";
import './WhatsAppButton.css'
import {ReactComponent as WhatsAppIcon} from "../../assets/footer-icons/cv/whatsapp-positive.svg"

const WHATSAPP_NUMBER = '34642348827'
const WHATSAPP_MESSAGE = "I'm%20inquiring%20about%20Get%20In%20Line%20fashion%20collection"
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${WHATSAPP_MESSAGE}`

function WhatsAppButton () {

  return (
    <a aria-label="Chat on WhatsApp"
    href={WHATSAPP_URL}
    className="whatsapp-float-button"
    target="_blank"
    rel="noopener noreferrer">
      <WhatsAppIcon className="social-icon" />
    </a>
  );
}

export default WhatsAppButton
